<script setup lang="ts">
// #719 観点B: モバイルナビ背景に敷くエリアのマップ画像。
import beachMapBg from '@/assets/images/map/AreaMap_SlumberingBeach.webp'

const runtimeConfig = useRuntimeConfig()

const { isMobile } = useIsMobile()

useSeoMeta({
  title: 'まどろみの浜辺 | Code & Magic',
  description: 'エンコーディア南部にある、浜辺です。',
  ogTitle: 'まどろみの浜辺 | Code & Magic',
  ogDescription: 'エンコーディア南部にある、浜辺です。',
  ogImage: `${runtimeConfig.public.serviceDomain}/images/ogPlayMakeShare_wLogo.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  middleware: ['authenticated', 'confirm-game-state'],
  layout: false,
  usePageReady: true,
})

const { finishLoading } = usePageReady()

onMounted(async () => {
  await finishLoading()
})
</script>

<template>
  <NuxtLayout :name="isMobile ? 'mobile-nav' : 'centering43'">
    <SceneMap
      scene-id="wld_slumberingBeach"
      :mobile="isMobile"
      :mobile-background="beachMapBg"
    >
      <template #map>
        <v-img
          src="@/assets/images/map/AreaMap_SlumberingBeach.webp"
          width="100%"
          height="auto"
          lazy-src="@/assets/images/map/LazyAreaMap_SlumberingBeach.png"
          :transition="false"
        />
        <svg
          class="map-area"
          width="100%"
          height="100%"
          viewBox="0 0 2048 1536"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          style="
          fill-rule: evenodd;
          clip-rule: evenodd;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 1.5;
        "
        >
          <path
            data-scene-id="slb_rockBench"
            d="M833.809,900.071c15.205,-48.484 33.136,-20.218 73.803,-79.849c32.915,-48.262 32.884,-131.171 83.597,-159.869c57.515,-32.547 161.469,1.96 226.148,37.089c58.654,31.856 125.889,86.841 145.64,134.784c19.713,47.854 13.988,118.999 -27.138,152.876c-41.913,34.526 -130.413,50.507 -202.629,55.181c-71.71,4.641 -168.131,0.434 -230.672,-27.138c-70.106,-30.907 -88.842,-49.003 -68.749,-113.074Z"
            class="scene"
          />
        </svg>
      </template>
    </SceneMap>
  </NuxtLayout>
</template>
